import request from '@/plugin/axios'

export function querySysConfigInfoByKey (data) {
  return request({
    url: '/api/admin/querySysConfigInfoByKey',
    method: 'get',
    params: data
  })
}
export function querySelectDataByOrg (data) {
  return request({
    url: '/api/admin/querySelectDataByOrg',
    method: 'post',
    data: data
  })
}
